module.exports = __webpack_public_path__ + "static/media/ticket-dashed-line.38b52bed.svg";